import React from "react";

function WhyUnito() {
    return (
        <div className="bg-[#222831] py-20 px-6 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">🚀 Why Unito?</h1>
            <p className="text-gray-300 mb-12 max-w-2xl mx-auto">
                Your all-in-one platform to track progress, master DSA, and connect with a like-minded coding community.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Feature 1 */}
                <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                    <h2 className="text-xl font-semibold text-white">📊 Track Progress</h2>
                    <p className="text-gray-300 mt-2">Visualize your streaks and improve with structured learning paths.</p>
                </div>
                {/* Feature 2 */}
                <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                    <h2 className="text-xl font-semibold text-white">🧠 Master DSA</h2>
                    <p className="text-gray-300 mt-2">Solve curated problems and understand concepts with expert guidance.</p>
                </div>
                {/* Feature 3 */}
                <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                    <h2 className="text-xl font-semibold text-white">🏆 Compete & Rank</h2>
                    <p className="text-gray-300 mt-2">Climb the leaderboard and challenge yourself with coding contests.</p>
                </div>
                {/* Feature 4 */}
                <div className="bg-[#393E46] p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                    <h2 className="text-xl font-semibold text-white">🤝 Community Support</h2>
                    <p className="text-gray-300 mt-2">Learn, collaborate, and grow with peers in a vibrant coding community.</p>
                </div>
            </div>
        </div>
    );
}

export default WhyUnito;
